export * from './lib/connection-message';
export * from './lib/useMicrophoneStream';
export * from './lib/useMicrophone';
export * from './lib/useSoundPlayer';
export * from './lib/useVoiceClient';
export * from './lib/VoiceProvider';
export * from './lib/errors';
export * from './lib/messages';
export * from './models/audio';
export * from './models/llm';
export * from './models/messages';
export * from './models/ttsService';
export * from './models/connect-options';

export type { SocketConfig } from './lib/useVoiceClient';
